var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeReload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -0.5 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-time-reload",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "687"), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.000000)",
    fill: "#32976b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.549,0.046 C4.69,0.046 1.73,3.238 1.383,7.031 L0.059,7.031 L1.951,8.983 L4.016,7.031 L2.677,7.031 C3.008,3.802 5.424,1.073 8.614,1.073 C12.026,1.073 14.803,3.961 14.803,7.51 C14.803,11.059 12.026,13.948 8.614,13.948 C6.919,13.948 5.382,13.235 4.264,12.083 L3.443,12.909 C4.776,14.185 6.572,14.974 8.549,14.974 C12.641,14.974 15.968,11.625 15.968,7.51 C15.968,3.395 12.641,0.046 8.549,0.046 L8.549,0.046 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,2.98962402 L8,8 L11.9597167,8 L11.9597167,7 L8.971,7 L8.97100003,2.98962402 C8.97200003,2.98962402 8,2.98962402 8,2.98962402 Z",
    className: "si-glyph-fill"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeReload);
export default __webpack_public_path__ + "static/media/time-reload.86f62f47375f4c400b025e41896dcc35.svg";
export { ForwardRef as ReactComponent };